import lightbox from 'fslightbox';
import { Calendar } from 'fullcalendar-scheduler';

(function(e) { "use strict"; e.fn.counterUp = function(t) { var n = e.extend({ time: 2000, delay: 10 }, t); return this.each(function() { var t = e(this), r = n, i = function() { var e = [], n = r.time / r.delay, i = t.text(), s = /[0-9]+,[0-9]+/.test(i); i = i.replace(/,/g, ""); var o = /^[0-9]+$/.test(i), u = /^[0-9]+\.[0-9]+$/.test(i), a = u ? (i.split(".")[ 1 ] || []).length : 0; for (var f = n; f >= 1; f--) { var l = parseInt(i / n * f); u && (l = parseFloat(i / n * f).toFixed(a)); if (s) while (/(\d+)(\d{3})/.test(l.toString())) l = l.toString().replace(/(\d+)(\d{3})/, "$1,$2"); e.unshift(l); } t.data("counterup-nums", e); t.text("0"); var c = function() { t.text(t.data("counterup-nums").shift()); if (t.data("counterup-nums").length) setTimeout(t.data("counterup-func"), r.delay); else { delete t.data("counterup-nums"); t.data("counterup-nums", null); t.data("counterup-func", null); } }; t.data("counterup-func", c); setTimeout(t.data("counterup-func"), r.delay); }; t.waypoint(i, { offset: "100%", triggerOnce: !0 }); }); }; })(jQuery);
const links = document.querySelectorAll('a');
//const imgs = document.querySelectorAll('img');


// Loop through each <a> element
links.forEach(link =>
{
	// Check if the <a> element already has a title attribute
	if (!link.hasAttribute('title'))
	{
		// Set the title attribute with the text content of the link
		let linkText = link.textContent.trim();

		// If the link text is not empty, use it as the title attribute
		if (linkText.length > 0)
		{
			link.setAttribute('title', linkText + ' - zobacz więcej');
		} else
		{
			// If the link text is empty, use the href as the title attribute
			link.setAttribute('title', document.title);
		}
	}
	if (!link.hasAttribute('aria-label'))
	{
		// Set the title attribute with the text content of the link
		let linkText = link.textContent.trim();

		// If the link text is not empty, use it as the title attribute
		if (linkText.length > 0)
		{
			link.setAttribute('aria-label', linkText + ' - zobacz więcej');
		} else
		{
			// If the link text is empty, use the href as the title attribute
			link.setAttribute('aria-label', document.title);
		}
	}
});
/*
imgs.forEach(img => {
	console.log(img.getAttribute('alt'));
	if (!img.hasAttribute('alt') || img.getAttribute('alt').length == 0) {
		let parent = img.parentNode;
		if(parent.hasAttribute('title') || parent.getAttribute('title')!=''){
			let text = parent.getAttribute('title');
			img.setAttribute('alt', text);
		}
	}

});*/
// Get all <a> elements that have <img> children
setTimeout(function()
{
	const images = document.querySelectorAll('img');

	images.forEach(function(img)
	{
		// Check if the img already has an alt attribute
		if (!img.hasAttribute('alt') || img.getAttribute('alt') === '')
		{
			// Get the direct parent of the img
			const parentLink = img.parentElement;

			// Check if the parent is an <a> and if it has a title attribute
			if (parentLink && parentLink.tagName === 'A' && parentLink.getAttribute('title'))
			{
				const linkTitle = parentLink.getAttribute('title');
				img.setAttribute('alt', linkTitle); // Set the <a> title as the img alt
			} else
			{
				// Fallback to using the page title if no valid parent or title is found
				img.setAttribute('alt', document.title);
			}
		}
	});
}, 500);
document.addEventListener('DOMContentLoaded', function()
{
	const menuItems = document.querySelectorAll('.menu-item-has-children > a');

	menuItems.forEach(item =>
	{
		item.addEventListener('keydown', function(e)
		{
			if (e.key === 'Enter' || e.key === ' ')
			{
				e.preventDefault();
				const subMenu = this.nextElementSibling;

				if (subMenu && subMenu.classList.contains('sub-menu'))
				{
					const isExpanded = subMenu.classList.contains('visible');
					subMenu.classList.toggle('visible', !isExpanded);
					subMenu.setAttribute('aria-expanded', !isExpanded);
				}
			}
		});
	});
});

jQuery(function()
{
	jQuery('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event)
		{
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			)
			{
				// Figure out element to scroll to
				var target = jQuery(this.hash);
				target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length)
				{
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					jQuery('html, body').animate({
						scrollTop: target.offset().top - 80
					}, 1000, function()
					{
						// Callback after animation
						// Must change focus!

					});
				}
			}
		});
	jQuery("#comment").attr('placeholder', 'Komentarz');
	if (document.getElementById('calendar'))
	{
		var calendarEl = document.getElementById('calendar');

		var calendar = new Calendar(calendarEl, {
			timeZone: 'Europe/Warsaw',
			events: function(fetchInfo, successCallback, failureCallback)
			{
				jQuery.ajax({
					url: '/wp-admin/admin-ajax.php',
					dataType: 'json',
					type: 'POST',
					locale: 'pl',
					data: {
						action: 'fetch_events'
					},
					success: function(data)
					{
						console.log('AJAX success:', data);
						var events = [];

						jQuery(data).each(function()
						{
							var dayNumbers = [];

							let currentDays = jQuery(this).attr('recurring_days');
							let recurring = jQuery(this).attr('recurring');
							jQuery.each(currentDays, function(i, val)
							{
								if (val == 'sunday') { dayNumbers.push(0); }
								if (val == 'monday') { dayNumbers.push(1); }
								if (val == 'tuesday') { dayNumbers.push(2); }
								if (val == 'wednesday') { dayNumbers.push(3); }
								if (val == 'thursday') { dayNumbers.push(4); }
								if (val == 'friday') { dayNumbers.push(5); }
								if (val == 'saturday') { dayNumbers.push(6); }
								if (val == 'sunday') { dayNumbers.push(7); }

							});
							if (recurring)
							{
								events.push({
									title: jQuery(this).attr('title'),
									//start: jQuery(this).attr('start'),
									startTime: jQuery(this).attr('start').slice(11, 16),
									location: jQuery(this).attr('location'),
									categories: jQuery(this).attr('categories'),
									url: jQuery(this).attr('url'),
									catCurrent: jQuery(this).attr('catCurrent'),
									daysOfWeek: dayNumbers,
									startRecur: jQuery(this).attr('start_date'),
									endRecur: jQuery(this).attr('end_date'),
								});
							}
							else
							{
								events.push({
									title: jQuery(this).attr('title'),
									start: jQuery(this).attr('start'),
									location: jQuery(this).attr('location'),
									categories: jQuery(this).attr('categories'),
									catCurrent: jQuery(this).attr('catCurrent'),
									url: jQuery(this).attr('url')
								});
							}

						});

						successCallback(events);
					},
					error: function(jqXHR, textStatus, errorThrown)
					{
						console.error('AJAX error:', textStatus, errorThrown);  // Log any errors
					}
				});
			},
			initialView: 'dayGridMonth',
			headerToolbar: {
				left: 'prev,title,next,timeGridDay,timeGridWeek,dayGridMonth',
				center: '',
				right: '' // user can switch between the two
			},
			firstDay: 1,
			views: {
				dayGridMonth: {
					buttonText: 'Miesiąc',
					aspectRatio: 1.3 // Adjust this to better fit on mobile

				},
				timeGridWeek: {
					buttonText: 'Tydzień' // Custom text for week view
				},
				timeGridDay: {
					buttonText: 'Dzień' // Custom text for day view
				}
			},
			eventContent: function(arg)
			{
				let eventEl = document.createElement('div');
				eventEl.classList.add('fc-event-title');

				setTimeout(() =>
				{
					if (eventEl.parentNode && eventEl.parentNode.parentNode)
					{
						eventEl.parentNode.parentNode.classList.add(arg.event.extendedProps.catCurrent);
					}
				}, 0);

				let startTime = '';
				let startDate = '';

				// Jeśli to zwykły event (ma pełny timestamp)
				if (arg.event.startStr)
				{
					const dateMatch = arg.event.startStr.match(/^(\d{4}-\d{2}-\d{2})/);
					const timeMatch = arg.event.startStr.match(/T(\d{2}:\d{2})/);
					if (dateMatch)
					{
						startDate = dateMatch[ 1 ];
					}
					if (timeMatch)
					{
						startTime = timeMatch[ 1 ];
					}
				}

				// Dla recurring event — tylko godzina
				if (!startTime && arg.event.extendedProps.startTime)
				{
					startTime = arg.event.extendedProps.startTime;
				}

				// Dodaj tytuł z datą/godziną
				if (arg.event.title)
				{
					let titleEl = document.createElement('div');
					titleEl.classList.add('event-title');

					// Buduj tekst: z datą jeśli jest
					let timeDisplay = '';
					if (startDate || startTime)
					{
						timeDisplay = `<span>${startDate ? startDate + ' ' : ''}${startTime}</span>`;
					}

					titleEl.innerHTML = `<strong>${arg.event.title}</strong> ${timeDisplay}`;
					eventEl.appendChild(titleEl);
				}

				// Lokalizacja + kategorie
				if (arg.event.extendedProps.location)
				{
					let locationEl = document.createElement('div');
					locationEl.innerHTML = 'Miejsce: ' + arg.event.extendedProps.location;

					if (arg.event.extendedProps.categories)
					{
						locationEl.innerHTML += arg.event.extendedProps.categories;
					}

					eventEl.appendChild(locationEl);
				}

				return { domNodes: [ eventEl ] };
			}


		});

		calendar.render();
		calendar.setOption('locale', 'pl');
	}
	jQuery(".display-submenu").on('click', function(e)
	{
		e.preventDefault();
		let currentButton = jQuery(this);
		let currentButtonNext = jQuery(this).next().hasClass('on');
		console.log(currentButtonNext);
		jQuery(".news-filter .submenu").removeClass('on');
		if (currentButtonNext)
			jQuery(this).next().removeClass('on');
		else
			jQuery(this).next().toggleClass('on');
	});
	/**Mobile menu **/
	jQuery('.arrow-down').on('click', function()
	{
		jQuery('html, body').animate({
			scrollTop: jQuery(".scrollable-col").offset().top - 80
		}, 1000, function()
		{
			// Callback after animation
			// Must change focus!

		});
	});
	//	jQuery('.article-content .wp-block-gallery a').attr('data-fslightbox', 'featured-image-lightbox');
	jQuery('.article-content .wp-block-image img').css('pointer-events', 'none');
	jQuery('#show_search').on('click', function()
	{
		jQuery(this).toggleClass('on');
		jQuery('.search_form').toggleClass('on');
		jQuery("#search-field").focus();
	});

	jQuery('.read-full-desc').on('click', function()
	{
		jQuery('.tab-nav-a').removeClass('active');
		jQuery('.tab-nav-a.desc-link').addClass('active');
		jQuery('.tabs-content > div').removeClass('active');
		jQuery('.product-desc-tab').addClass('active');
		jQuery('html, body').animate({
			scrollTop: jQuery(".product-desc-tab").offset().top - 160
		}, 1000, function()
		{
			// Callback after animation
			// Must change focus!

		});
	});


	jQuery('.hamburger').on('click', function()
	{
		jQuery(this).toggleClass('open-h');
		jQuery('.mobile-overlay').toggleClass('small-h');
	});

	jQuery('.side-hamburger').on('click', function()
	{
		jQuery(this).toggleClass('open-h');
		jQuery('.about-us-sidebar').toggleClass('small-h');
		jQuery('.project-sidebar').toggleClass('small-h');
	});

	jQuery('.tab-nav-a').on('click', function(event)
	{
		jQuery('.tab-nav-a').removeClass('active');
		jQuery(this).addClass('active');

	});

	jQuery('.signup').on('click', function(e)
	{
		e.preventDefault();
		jQuery('.event-popup-wrapper').addClass('on');
	});
	jQuery('.event-popup-wrapper .close').on('click', function(e)
	{
		e.preventDefault();
		jQuery('.event-popup-wrapper').removeClass('on');
	});

	jQuery('.desc-link').on('click', function(event)
	{
		jQuery('.product-data-tab').removeClass('active');
		jQuery('.product-additional-tab').removeClass('active');
		jQuery('.product-desc-tab').addClass('active');

	});

	jQuery('.data-link').on('click', function(event)
	{
		jQuery('.product-data-tab').addClass('active');
		jQuery('.product-additional-tab').removeClass('active');
		jQuery('.product-desc-tab').removeClass('active');

	});

	jQuery('.add-link').on('click', function(event)
	{
		jQuery('.product-data-tab').removeClass('active');
		jQuery('.product-additional-tab').addClass('active');
		jQuery('.product-desc-tab').removeClass('active');

	});

	jQuery('.cart-link').on('click', function(event)
	{
		jQuery('.product-data-tab').removeClass('active');
		jQuery('.product-cart-tab').addClass('active');
		jQuery('.product-additional-tab').removeClass('active');
		jQuery('.product-desc-tab').removeClass('active');

	});

	jQuery('#product-gallery, #product-gallery3, #product-gallery4').slick({
		autoplay: false,
		slidesToScroll: 4,
		slidesToShow: 4,
		arrows: true,
		infinite: true,
		dots: false,
		adaptiveHeight: true,
		prevArrow: '<a class="arrow-prev" aria-label="Poprzednie" role="button"><i class="arrow_carrot-left"></i></a>',
		nextArrow: '<a class="arrow-next" aria-label="Następne" role="button"><i class="arrow_carrot-right"></i></a>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	jQuery('#product-gallery5').slick({
		autoplay: false,
		slidesToScroll: 5,
		slidesToShow: 5,
		arrows: true,
		infinite: true,
		dots: false,
		adaptiveHeight: true,
		prevArrow: '<a class="arrow-prev" aria-label="Poprzednie" role="button"><i class="arrow_carrot-left"></i></a>',
		nextArrow: '<a class="arrow-next" aria-label="Następne" role="button"><i class="arrow_carrot-right"></i></a>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});

	jQuery('.home_slide_section .to-slick').slick({
		infinite: true,
		centerMode: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		fade: true,
		adaptiveHeight: true,
		cssEase: 'linear',
		speed: 500,
		prevArrow: '<a class="arrow-prev" aria-label="Poprzednie" role="button"><i class="arrow_carrot-left"></i></a>',
		nextArrow: '<a class="arrow-next" aria-label="Następne" role="button"><i class="arrow_carrot-right"></i></a>',
		autoplay: true,
		autoplaySpeed: 3000
	});

	jQuery('.page-template-o-nas .single-article-gallery .to-slick, .page-content-wolontariat .single-article-gallery .to-slick,  .page-content-edukacja-small .single-article-gallery .to-slick, .page-content-seniorzy .single-article-gallery .to-slick,  .page-content-pomoc .single-article-gallery .to-slick,  .page-content-wielokulturowosc .single-article-gallery .to-slick').slick({
		infinite: true,
		centerMode: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		fade: true,
		autoplay: true,
		cssEase: 'linear',
		speed: 500,
		prevArrow: '<a class="arrow-prev" aria-label="Poprzednie" role="button"><i class="arrow_carrot-left"></i></a>',
		nextArrow: '<a class="arrow-next" aria-label="Następne" role="button"><i class="arrow_carrot-right"></i></a>',
		autoplay: true,
		autoplaySpeed: 3000
	});

	jQuery('#partners_slick').slick({
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 5,
		arrows: true,
		dots: false,
		prevArrow: '<a class="arrow-prev" aria-label="Poprzednie" role="button"><i class="arrow_carrot-left"></i></a>',
		nextArrow: '<a class="arrow-next" aria-label="Następne" role="button"><i class="arrow_carrot-right"></i></a>',
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	jQuery('*').removeClass('has-x-large-font-size');
	// MENU FIXED
	if (jQuery('.header').length)
	{
		var scrollTrigger = 50, // px
			nagFix = function()
			{
				var scrollTop = jQuery(window).scrollTop();
				if (scrollTop > scrollTrigger)
				{
					jQuery('.header').addClass('header--small', 1000, "easeOutBounce");
					jQuery('.scrollToTop').addClass('on', 1000, "easeOutBounce");
					//	jQuery('.mobile-overlay').removeClass('small-h');
				} else
				{
					jQuery('.header').removeClass('header--small', 1000, "easeOutBounce");
					jQuery('.scrollToTop').removeClass('on', 1000, "easeOutBounce");
					//		jQuery('.mobile-overlay').removeClass('small-h');
				}
			};
		nagFix();
		jQuery(window).on('scroll', function()
		{
			nagFix();
		});
	};
	jQuery(window).on('scroll', function()
	{
		var scrollTop = jQuery(window).scrollTop();
		if (scrollTop > 50)
		{
			jQuery(".scrollToTop").addClass('button-show');
		}
		else
		{
			jQuery(".scrollToTop").removeClass('button-show');
		}
	});
});

// Select all menu items with sub-menus
const parentMenuItems = document.querySelectorAll('.mobile-overlay .menu-item-has-children > a');

parentMenuItems.forEach(parentItem =>
{
	// Create an arrow element and append it next to the parent item (category name)
	const arrow = document.createElement('span');
	arrow.classList.add('arrow'); // Add class for styling the arrow
	parentItem.parentNode.appendChild(arrow); // Add arrow after the parentItem (category link)

	// Add a click event to the arrow (not the category name)
	arrow.addEventListener('click', function(e)
	{
		// Prevent the click event from affecting the parent link
		e.stopPropagation();

		// Get the corresponding sub-menu
		const subMenu = parentItem.nextElementSibling;

		// Toggle the 'open' class to show/hide the sub-menu
		if (subMenu)
		{
			subMenu.classList.toggle('open');

			// Optionally, close other open sub-menus
			// Uncomment the following lines if you want only one sub-menu to be open at a time
			// document.querySelectorAll('.sub-menu.open').forEach(menu => {
			//   if (menu !== subMenu) {
			//     menu.classList.remove('open');
			//   }
			// });
		}
	});
});

// Dodaj aria-label do pól formularzy
document.addEventListener('DOMContentLoaded', function()
{
	document.querySelectorAll('.form-element').forEach(function(formElement)
	{
		// Standardowe pola (input/select wewnątrz label)
		var mainLabel = formElement.querySelector('label .main-label');
		if (mainLabel)
		{
			var labelText = mainLabel.textContent.trim();
			formElement.querySelectorAll('label input, label select').forEach(function(field)
			{
				if (!field.closest('.checkbox-cover') && !field.hasAttribute('aria-label'))
				{
					field.setAttribute('aria-label', labelText);
				}
			});
		}

		// Pola checkbox/radio
		formElement.querySelectorAll('.checkbox-cover').forEach(function(cover)
		{
			var spanLabel = cover.querySelector('span .main-label span');
			if (spanLabel)
			{
				var spanLabelText = spanLabel.textContent.trim();
				cover.querySelectorAll('input').forEach(function(input)
				{
					var value = input.value ? input.value.trim() : '';
					var ariaText = spanLabelText + (value ? ' - ' + value : '');
					if (!input.hasAttribute('aria-label'))
					{
						input.setAttribute('aria-label', ariaText);
					}
				});
			}
		});
	});

	// Przycisk submit
	document.querySelectorAll('input[type="submit"], button[type="submit"]').forEach(function(btn)
	{
		if (!btn.hasAttribute('aria-label'))
		{
			btn.setAttribute('aria-label', 'Wyślij formularz');
		}
	});

	document.querySelector('.fc-icon-chevron-right').setAttribute('aria-label', 'Następny miesiąc');
	document.querySelector('.fc-icon-chevron-left').setAttribute('aria-label', 'Poprzedni miesiąc');
	document.querySelector('.fc-icon-chevron-right').setAttribute('alt', 'Następny miesiąc');
	document.querySelector('.fc-icon-chevron-left').setAttribute('alt', 'Poprzedni miesiąc');

});
